import { render, staticRenderFns } from "./transactionNot.vue?vue&type=template&id=599c9334&scoped=true&"
import script from "./transactionNot.vue?vue&type=script&lang=js&"
export * from "./transactionNot.vue?vue&type=script&lang=js&"
import style0 from "./transactionNot.vue?vue&type=style&index=0&id=599c9334&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599c9334",
  null
  
)

export default component.exports